import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

export default function FrontOfPackage ({hasHighSatFat = false, hasHighSugars = false, hasHighSodium = false}) {

    const [label, setLabel] = useState();

    useEffect(() => {
        if(hasHighSatFat || hasHighSugars || hasHighSodium) {
            const imageDomain = `https://s3.amazonaws.com/nutrition-calculator.tis.coke.com/static/media`
            setLabel(`${imageDomain}/high${hasHighSatFat ? '1' : '0'}${hasHighSugars ? '1' : '0'}${hasHighSodium ? '1' : '0'}.png`)
        } else {
            setLabel(undefined)
        }
    }, [hasHighSatFat, hasHighSugars, hasHighSodium])

    return (
        <>
            {(hasHighSatFat || hasHighSugars || hasHighSodium) &&
                <>
                    <Typography>Front of Package: </Typography>
                    <Box id="front-of-package-label">
                        <img style={{marginBottom: '1em'}} src={label} alt="Front of Package Label"/>
                    </Box>
                </>
            }
        </>
    )
}